import React from 'react'
import { IconWrapper } from '../IconWrapper'
import type { IconWrapperProps } from '../IconWrapper'

export const EcommSocialGoogleIcon = React.forwardRef<SVGSVGElement, IconWrapperProps>(
  (props, forwardedRef) => {
    return (
      <IconWrapper {...props}>
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          {...props}
          ref={forwardedRef}
        >
          <path
            d="M6.31016 12C6.31016 11.3505 6.41797 10.7277 6.61062 10.1436L3.24031 7.57C2.58344 8.90359 2.21344 10.4064 2.21344 12C2.21344 13.5923 2.58312 15.0941 3.23891 16.4269L6.60734 13.8483C6.41656 13.2669 6.31016 12.6464 6.31016 12Z"
            fill="#FBBC05"
            fillRule="evenodd"
            clipRule="evenodd"
          />
          <path
            d="M12.2277 6.09094C13.6388 6.09094 14.9133 6.59094 15.9147 7.40906L18.8278 4.5C17.0527 2.95453 14.7767 2 12.2277 2C8.27016 2 4.86891 4.26312 3.24031 7.57L6.61062 10.1436C7.38719 7.78641 9.60063 6.09094 12.2277 6.09094Z"
            fill="#EA4335"
            fillRule="evenodd"
            clipRule="evenodd"
          />
          <path
            d="M12.2277 17.9091C9.60078 17.9091 7.38719 16.2136 6.61062 13.8564L3.24031 16.4295C4.86891 19.7369 8.27016 22 12.2277 22C14.6702 22 17.0022 21.1327 18.7523 19.5077L15.5533 17.0345C14.6506 17.6031 13.5139 17.9091 12.2277 17.9091Z"
            fill="#34A853"
            fillRule="evenodd"
            clipRule="evenodd"
          />
          <path
            d="M21.7866 12C21.7866 11.4091 21.6955 10.7727 21.5589 10.1819H12.2277V14.0455H17.5989C17.3303 15.3628 16.5994 16.3755 15.5533 17.0345L18.7523 19.5077C20.5908 17.8014 21.7866 15.2595 21.7866 12Z"
            fill="#4285F4"
            fillRule="evenodd"
            clipRule="evenodd"
          />
        </svg>
      </IconWrapper>
    )
  },
)
